module.exports = __webpack_public_path__ + "img/kompleks_diag.13b35be1.svg";